import './App.css';
import { Alert, CssBaseline, Stack, ThemeProvider, Typography } from '@mui/material';
import { theme } from './theme';
import { RouterProvider } from 'react-router-dom';
import ReactGA from 'react-ga';
import useAuthStore from './stores/useAuthStore';
import { authRouter, unauthRouter } from './router';
import GlobalAlert from './components/layout/GlobalAlert';
import { useEffect } from 'react';

const TRACKING_ID = "G-XFMX276CPG"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  const { loggedIn, user } = useAuthStore();

  const environment = process.env.REACT_APP_ENVIRONMENT;

  useEffect(() => {
    ReactGA.set({ userId: user?.id, loggedIn: loggedIn });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [window.location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalAlert />
      <RouterProvider router={loggedIn ? authRouter : unauthRouter} />
      {environment !== 'production' && <Stack direction="row" position="fixed" bottom={0} width="100%" p={2} justifyContent="center">
        <Alert severity='warning'>
          <Typography sx={{ my: 'auto !important' }}>
            This is a test environment!
          </Typography>
        </Alert>
      </Stack>}
    </ThemeProvider>
  );
}

export default App;
